<ng-container>
	<div class="header">
		<div class="title">{{ "notification_center_title" | translate }}</div>
		<bp-icon
			class="close-notification"
			[style.color]="'var(--color-neutral-75)'"
			(click)="onCloseNotifications()"
			icon="dismiss"
			size="24"
			theme="regular">
		</bp-icon>
	</div>
	<div class="content">
		<notifications-list></notifications-list>
	</div>
</ng-container>
